<template>
  <lsSearchForm
    ref="lsSearchForm"
    @search="handleSearch"
    :initExpand="false"
    :formList="formList"
    :searchContentFold="false"
  >
    <!--加工组织-->
    <global-select
      slot="organizationCode"
      selectType="selectAssemble"
      requestApi="/system/user/inventOrgAll"
      :selectItem="{ value: 'realValue', label: 'label' }"
      :dropdown-match-select-width="false"
      v-decorator="['organizationCode']"
      :assembleLabel="true"
      placeholder="请选择"
    />
  </lsSearchForm>
</template>

<script>
import isNil from 'lodash/isNil';
import { apiBomRoutingHeaderFindList } from '@/api/mes/basedata/standardProcess';
import { mapState } from 'vuex';
import { STATUS_CODE } from '../enums.js';

export default {
  name: 'SearchForm',
  components: {},
  data() {
    return {
      routingList: []
    }
  },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg
    }),
    formList() {
      const result = [
        {
          label: "加工组织",
          type: "organizationCode"
        },
        {
          label: "工艺路线名称",
          type: "input",
          decorator: ["routingDesc"],
          attrs: {
            placeholder: "请输入"
          }
        },
        {
          label: "状态",
          type: "select",
          decorator: ["routingStatus"],
          attrs: {
            placeholder: "请选择"
          },
          options: Object.values(STATUS_CODE).map(item => {
            return {
              key: item.value,
              value: item.label
            }
          })
        }
      ]
      return result;
    }
  },
  methods: {
    handleSearch(values) {
      for(const filed in values) {
        if(isNil(values[filed]) || values[filed] === '') {
          delete values[filed]
        }
      }
      delete values.searchFormLabel
      this.$emit("search", values);
    },
    handleFormSearch() {
      this.$refs.lsSearchForm.handleSearch();
    },
    // 加工组织
    onInventOrgChange (val, status) {
      apiBomRoutingHeaderFindList({ organizationCode: val, isStandardRoutingFlag: "Y" }).then(res => {
        if (res && res.length > 0) {
          this.routingList = res
          this.form.setFieldsValue({
            routingId: res[0].id,
            routingDesc: res[0].routingDesc
          })

          status === "yes" && this.handleQuery()
        } else {
          this.routingList = []
          this.form.setFieldsValue({
            routingId: "",
            routingDesc: ""
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped></style>
